export const LOGO_URL = "/assets/family-bank-logo.png";
export const APP_ICON_URL = "/icons/family-bank-app-icon.png";
